/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/not-a-toast@1.1.5/dist/not-a-toast.umd.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
